import logo from 'assets/images/ACA-logo.svg';

const Logo = () => {
    return (
        <img src={logo} alt="Berry" width="100" />
    );
};

export default Logo;
